import { render, staticRenderFns } from "./AddDnsModal.vue?vue&type=template&id=6716aacb&"
import script from "./AddDnsModal.vue?vue&type=script&lang=js&"
export * from "./AddDnsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports